import React, { Component } from "react"
import { NamespacesConsumer as I18n } from "react-i18next"
import { NotificationManage } from "../../components/NotificationManage"
import { connect } from "react-redux"
import { compose } from "redux"

//component
import * as user_actions from "../../actions/action_user"
import Tooltip from "../../components/Tooltip"

//material ui
import PropTypes from "prop-types"
import TextField from "@material-ui/core/TextField"
import Avatar from "@material-ui/core/Avatar"
import Button from "@material-ui/core/Button"
import FormControl from "@material-ui/core/FormControl"
import VpnKeyIcon from "@material-ui/icons/VpnKey"
import Typography from "@material-ui/core/Typography"
import withStyles from "@material-ui/core/styles/withStyles"
import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"
import CircularProgress from "@material-ui/core/CircularProgress"
import { RestorenameStyle } from "../Style/RestorenameStyle"

class Restorename extends Component {
	constructor(props) {
		super(props)
		this.state = {
			given_name: "",
			family_name: ""
		}
	}
	handleChange = event => {
		this.setState({ [event.target.id]: event.target.value })
	}
	validateForm() {
		if (this.state.given_name === "" || this.state.family_name === "") {
			return false
		}
		return true
	}
	handleConfirmationSubmit = (event, t) => {
		event.preventDefault()
		const { handleClickClose } = this.props
		let { given_name, family_name } = this.state
		this.props
			.updateUserAttributes({
				given_name,
				family_name
			})
			.then(result => {
				if (result.value) {
					NotificationManage(
						"success",
						`Welcome ${result.value.result.attributes.given_name} ${result.value.result.attributes.family_name}`,
						`${t("NotificationManager.status.success")}`
					)
				}
				handleClickClose()
			})
			.catch(err => {
				NotificationManage(
					"error",
					`${t("NotificationManager.Project.try")}`,
					`${t("NotificationManager.status.Error")}`
				)
			})
	}

	render() {
		const { classes, Open, finish } = this.props
		let { given_name, family_name } = this.state
		return (
			<I18n>
				{t => {
					return (
						<div>
							<Dialog
								open={Open}
								aria-labelledby="alert-dialog-title"
								aria-describedby="alert-dialog-description"
							>
								<DialogContent className={classes.paper}>
									<Avatar className={classes.avatar}>
										<VpnKeyIcon />
									</Avatar>
									<Typography
										variant="h5"
										component="h3"
										style={{ fontSize: 18, fontFamily: "Roboto, sans-serif" }}
									>
										{t("register.RestoreName")}
									</Typography>
									<form className={classes.form}>
										<div className="row">
											<div className="col-lg-6 col-md-12 col-sm-12">
												<FormControl className={classes.FormControl} fullWidth>
													<Tooltip content={t("register.RegisterValidName")}>
														<TextField
															id="given_name"
															label={t("register.RegisterFirstName")}
															placeholder={t("register.RegisterEnterFirstName")}
															value={given_name}
															onChange={this.handleChange}
															InputLabelProps={{
																FormLabelClasses: {
																	asterisk: classes.labelAsterisk
																}
															}}
														/>
													</Tooltip>
												</FormControl>
											</div>
											<div className="col-lg-6 col-md-12 col-sm-12">
												<FormControl className={classes.FormControl} fullWidth>
													<Tooltip content={t("register.RegisterValidName")}>
														<TextField
															id="family_name"
															label={t("register.RegisterLastName")}
															placeholder={t("register.RegisterEnterLastName")}
															value={family_name}
															onChange={this.handleChange}
															InputLabelProps={{
																FormLabelClasses: {
																	asterisk: classes.labelAsterisk
																}
															}}
														/>
													</Tooltip>
												</FormControl>
											</div>
										</div>
										<div className={classes.root}>
											<div className={classes.wrapper}>
												<Button
													aria-label="handleConfirmationSubmit"
													type="submit"
													fullWidth
													variant="contained"
													color="primary"
													className={classes.submit}
													disabled={!this.validateForm() || finish}
													onClick={event =>
														this.handleConfirmationSubmit(event, t)
													}
												>
													{t("button.buttonsubmit")}
												</Button>
												{finish && (
													<CircularProgress
														size={24}
														className={classes.buttonProgress}
													/>
												)}
											</div>
										</div>
									</form>
								</DialogContent>
							</Dialog>
						</div>
					)
				}}
			</I18n>
		)
	}
}
Restorename.propTypes = {
	classes: PropTypes.object.isRequired
}
function mapStateToProps(reduxState) {
	return {
		user: reduxState.UserReducer.user,
		finish: reduxState.UserReducer.finish
	}
}
const mapDispatchToProps = function(dispatch) {
	return {
		updateUserAttributes: info =>
			dispatch(user_actions.updateUserAttributes(info))
	}
}

export default compose(
	withStyles(RestorenameStyle),
	connect(mapStateToProps, mapDispatchToProps)
)(Restorename)
